import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { ButtonEditSummary } from '../../../style';

export const ButtonEditSummaryItem = ({ onClick }) => {
  return (
    <ButtonEditSummary onClick={onClick} type="text" shape="circle">
      <FeatherIcon icon="edit-3" size={14} />
    </ButtonEditSummary>
  );
};

ButtonEditSummaryItem.propTypes = {
  onClick: PropTypes.func,
};
